import type { Route } from './route'

/**
 * Returns true if route a should be ranked before route b.
 *
 * Ranking priority (4 levels, mirroring Go/Swift/Kotlin per TASK-275):
 * 1. Fewer transfer_count
 * 2. Shorter total_time_s (when transfers equal)
 * 3. Less walking_time_s (when transfers + time equal)
 * 4. Lexicographically smaller id (tie-break for stable ordering)
 *
 * Transfers come first because TfL users overwhelmingly prefer fewer
 * line changes even at the cost of a few minutes of in-vehicle time.
 */
export function scoreLess(a: Route, b: Route): boolean {
  if (a.transfer_count !== b.transfer_count) return a.transfer_count < b.transfer_count
  if (a.total_time_s !== b.total_time_s) return a.total_time_s < b.total_time_s
  if (a.walking_time_s !== b.walking_time_s) return a.walking_time_s < b.walking_time_s
  return a.id < b.id
}
